export default __webpack_public_path__ + "static/media/Edit.a7ebd56c.svg";